import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import FormSteps from './FormSteps';
import BaseForm from './Forms/Base';

const CottageCreate = ({
  onClose,
  onSubmit,
  isLoading,
}) => {
  const theme = useTheme();
  const fullscreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <>
      <FormSteps
        completedArray={[]}
        requiredSteps={[]}
        cottage={{}}
        currentStep="base"
      />
      <Dialog
        fullScreen={fullscreen}
        fullWidth
        maxWidth="lg"
        onClose={onClose}
        open
      >
        <BaseForm
          onSubmit={onSubmit}
          onClose={onClose}
          isLoading={isLoading}
          isNew
        />
      </Dialog>
    </>
  );
};

CottageCreate.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default CottageCreate;
